import React, {useState, useEffect} from 'react';
import {BrowserRouter as Router, Routes, Route, Link, Switch} from 'react-router-dom';

import MichassAccueil from './MichassAccueil';
import MichassIndex from './MichassIndex';
import MichassMenu from './MichassMenu';
import MichassPresentation from './MichassPresentation';
import MichassPresentationHistorique from './MichassPresentationHistorique';
import MichassPresentationEquipe from './MichassPresentationEquipe';
import MichassPresentationMission from './MichassPresentationMission';
import MichassPresentationCommunaute from './MichassPresentationCommunaute';
import MichassEnseignements from './MichassEnseignements';
import MichassEnseignement from './MichassEnseignement';
import MichassCultes from './MichassCultes';
import MichassCulte from './MichassCulte';
import MichassActualites from './MichassActualites';
import MichassActualite from './MichassActualite';
import MichassGalerie from './MichassGalerie';
import MichassContact from './MichassContact';
import MichassFooter from './MichassFooter';

import './App.css';

function AppPage() {
  return (
    <Router>
      <div className="w-full">
        <div className="flex">
          <div className="w-full">
            <MichassMenu />
            <Routes>
              <Route path="/" element={<MichassIndex />} />
              <Route path="/presentation" element={<MichassPresentation />} />
              <Route path="/galerie" element={<MichassGalerie />} />
              <Route path="/cultes" element={<MichassCultes />} />
              <Route path="/enseignements" element={<MichassEnseignements />} />
              <Route path="/contact" element={<MichassContact />} />
            </Routes>
            <MichassFooter />
            <div className="michass-page-introuvable flex-col">
              <p>
                Erreur <br/>
                Cette page est introuvable !
              </p>
            </div>
          </div>
        </div>
      </div>
    </Router>
  );
}

function App() {
  const [michassLoading, startMichassLoading] = useState(true);
  useEffect(() => {
    const michassLoadingTime = setTimeout(() => {
      startMichassLoading(false);
    }, 2500);
    return () => clearTimeout(michassLoadingTime);
  }, []);

  return (
    <div className="flex flex-row w-full">
      {michassLoading ? <MichassAccueil /> : <AppPage />}
    </div>
  );
}

export default App;
